import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import Data from '~components/Data'
import Image from '~components/Image'
import { ReactComponent as QuotationSvg } from '~media/state-of-chaos-engineering/quotation.svg'

export function Quotation({ variation, ...rest }) {
  const theme = useTheme()

  let quoteColor

  if (variation === 'green') {
    quoteColor = theme.color.primary.base
  } else if (variation === 'blue') {
    quoteColor = '#2B4697'
  } else if (variation === 'introduction') {
    quoteColor = theme.color.panel.base
  }

  return (
    <QuotationSvg
      css={{
        color: quoteColor,
        position: 'absolute',
        zIndex: -1,
        width: theme.fontSize.xlarge,
      }}
      {...rest}
    />
  )
}

Quotation.propTypes = {
  variation: PropTypes.oneOf(['green', 'blue', 'introduction']),
}

export default function Quote({
  variation = 'green',
  children,
  author,
  meta,
  logo,
  ...rest
}) {
  const theme = useTheme()

  return (
    <div
      css={{
        marginTop: theme.space.large,
        marginBottom: theme.space.large,

        [theme.mq.medium]: {
          marginTop: theme.space.xlarge,
          marginBottom: theme.space.xlarge,
        },
      }}
    >
      <div
        css={{
          ...theme.text['2xlarge__fluid'],
          position: 'relative',
          zIndex: 1,
          lineHeight: theme.lineHeight.small,
        }}
        {...rest}
      >
        <Quotation
          variation={variation}
          css={{ transform: 'rotate(180deg) translateX(50%)' }}
        />
        <span
          css={{
            span: {
              fontWeight: 100,
            },
          }}
        >
          <Data>{children}</Data>
        </span>
        <Quotation
          variation={variation}
          css={{ bottom: 0, transform: 'translateX(25%)' }}
        />
      </div>
      {(author || logo || meta) && (
        <div
          css={{
            marginTop: theme.space.base,
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: theme.space.small,

            [theme.mq.medium]: {
              gridTemplateColumns: 'auto',
              gap: theme.space.base,
              marginTop: theme.space.large,
              gridAutoFlow: 'column',
              gridAutoColumns: 'auto',
              justifyContent: 'start',
              alignItems: 'center',
            },
          }}
        >
          {author && (
            <div
              css={{
                textTransform: 'uppercase',
                letterSpacing: theme.letterSpacing.extended,
              }}
            >
              {meta && (
                <div
                  css={{
                    fontWeight: 100,
                  }}
                >
                  <Data>{meta}</Data>
                </div>
              )}
              <div
                css={{
                  fontWeight: theme.fontWeight.bold,
                }}
              >
                <Data>{author}</Data>
              </div>
            </div>
          )}
          {logo && (
            <Image
              src={logo}
              css={{
                height: theme.height.small,
                filter: 'brightness(0) invert(1)',
              }}
            />
          )}
        </div>
      )}
    </div>
  )
}
Quote.propTypes = {
  author: PropTypes.string,
  children: PropTypes.node.isRequired,
  logo: PropTypes.string,
  meta: PropTypes.string,
  variation: PropTypes.oneOf(['green', 'blue', 'introduction']),
}
